interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const ArrowRightNewLayout = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill={color} className={className}>
        <path d="M7.76894 8L0.158031 15.1352C-0.0434251 15.3241 -0.0536321 15.6405 0.135233 15.842C0.324098 16.0434 0.640516 16.0536 0.841972 15.8648L8.84197 8.36477C9.05268 8.16723 9.05268 7.83277 8.84197 7.63523L0.841972 0.135233C0.640516 -0.0536321 0.324098 -0.0434251 0.135233 0.158031C-0.0536321 0.359487 -0.0434251 0.675905 0.158031 0.86477L7.76894 8Z" fill={color} />
      </svg>
    </>
  );
}

export default ArrowRightNewLayout;